<template>
<!-- BASLIK ALANI -->
  <div id="extra-component-chartist-demo" v-if="monthlies">

    <div class="section-heading" v-if="activeUserInfo.user_group === 4">
      <div class="tr-button green-button" @click="addUser = !addUser"><i class="fas fa-plus"></i> Create a Restaurant</div>
    </div>

    <div v-if="addUser" data-vv-scope="add-user" class="user-edit-cont">
      <h3 style="color:#ff2400;margin-bottom:20px;">*Only Master Admin Can Create New User</h3>
      <div class="user-edit-row">
        <h4>First Name*</h4>
        <input type="text" class="tr-input" v-model="name" name="Name" v-validate="'required'">
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Last Name</h4>
        <input type="text" class="tr-input" v-model="last_name" name="Last Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Email*</h4>
        <input type="email" class="tr-input" v-model="email" name="Email" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
        <span>User will login with this email.</span>
      </div>
      <div class="user-edit-row">
        <h4>Password*</h4>
        <input type="password" class="tr-input"
               data-vv-validate-on="blur"
               v-validate="'required|min:6|max:10'"
               name="password"
               v-model="password"/>
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>
        <span>Create a temporary password for this user. Users can change their passwords later.</span>
      </div>
      <div class="user-edit-row">
        <h4>Role</h4>
        <select v-model="user_group">
          <option v-for="(item, index) in user_group_options" :key="index" :value="item.value">{{item.label}}</option>
        </select>
        <div class="role-exp">
          <ul>
            <li v-if="user_group === 2"><strong>Restaurant:</strong> Authorized for order management only.</li>
          </ul>
        </div>
      </div>
      <div class="role-exp">
        <p>* Upon creating a new user, this user will be notified with login instructions through email you entered above. They will also see the password you created for them. Once they login they can change these settings by themselves.</p>
      </div>
      <div class="tr-button green-button" @click="submitData">CREATE USER</div>
      <div class="tr-button green-button inactive" @click="addUser = false">CANCEL</div>
    </div>
    <div v-else>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Total Sales">
          <span class="nd-im-txt">${{ totals.orderTotal }}</span>
          </vx-card>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Total Orders">
            <span class="nd-im-txt">{{ totals.orderCount }}</span>
          </vx-card>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Average Order Size">
            <span class="nd-im-txt">${{ totals.orderAvg }}</span>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
      <div class="vx-col w-full ">

        <vx-card title="">
          <div class="mt-5">
            <vs-tabs>
              <vs-tab label="Orders">
                <div class="tab-text">
                  <vue-apex-charts type="line" height="417" :options="chartOptions" :series="graphData"></vue-apex-charts>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>

          <template slot="codeContainer">
            &lt;vs-tabs&gt;
            &lt;vs-tab label=&quot;Sales&quot;&gt;
            &lt;div class=&quot;tab-text&quot;&gt;
            &lt;span&gt;Sales ....&lt;/span&gt;
            &lt;/div&gt;
            &lt;/vs-tab&gt;
            &lt;vs-tab label=&quot;Orders&quot;&gt;
            &lt;div class=&quot;tab-text&quot;&gt;
            &lt;span&gt;Orders ...&lt;/span&gt;
            &lt;/div&gt;
            &lt;/vs-tab&gt;
            &lt;/vs-tabs&gt;
          </template>

        </vx-card>

      </div>

      <!-- Bar CHART -->
      <div class="vx-col md:w-2/5 w-full mb-base" v-if="weeklies">
        <vx-card title="Average sales by day" subtitle="This month">
          <vue-apex-charts type="bar" height="350" :options="barChartOptions" :series="weekGraphData"></vue-apex-charts>
        <div class="explanation-button-wrapper">
        <p>Increase sales on low volume days with a time-targetted <code>promotion</code></p>
        <div class="button-wrapper"><vs-button color="primary" type="border">Create promotion</vs-button></div>
        </div>
        </vx-card>
      </div>


    </div>
    </div>
  </div>
</template>

<script>
const themeColors = ['#0d90ff', '#1ca77d', '#E51630', '#f59c1a', '#1E1E1E']
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import apexChatData from './charts-and-maps/charts/apex-charts/apexChartData.js'
export default {
  data () {
    return {
      apexChatData,
      addUser: false,
      selectedMonth: moment().month(),
      monthlies: [],
      weeklies: null,
      editUser: false,
      user_group: 2,
      user_group_options: [{label: 'Restaurant', value: 2}],
      name: '',
      last_name: '',
      email: '',
      format: 'yyyy-MM-dd',
      password: '',
      barChartOptions: {
        colors: themeColors,
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        }
      },
      chartOptions: {
        chart: {
          height: 350,
          zoom: {
            enabled: false
          }
        },
        colors: themeColors,
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Product Trends by Month',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: moment.monthsShort()
        }
      }
    }
  },
  components: {
    VueApexCharts,
    moment
  },
  computed: {
    graphData () {
      const result = []
      this.monthlies.map(month => {
        const data = month[Object.keys(month)[0]].data
        result.push(data.length)
      })

      return [
        {
          name: 'Orders',
          data: result
        }
      ]
    },
    weekGraphData () {
      const result = [0, 0, 0, 0, 0, 0, 0]
      this.weeklies.map(week => {
        week.orders.map(order => {
          const date = moment(order.order_date)
          result[date.day()]++
        })
      })

      return [
        {
          name: 'Orders',
          data: result
        }
      ]
    },
    totals () {
      let orderCount = 0
      let orderTotal = 0
      let orderAvg = 0
      this.monthlies.map(month => {
        const orders = month[Object.keys(month)[0]].data
        orders.map(order => {
          orderTotal += order.total_amount
        })
        orderCount += orders.length
      })
      orderAvg = (orderTotal / orderCount).toFixed(2)
      return {
        orderCount,
        orderTotal: orderTotal.toFixed(2),
        orderAvg
      }
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    },
    activeUserInfo () {
      return this.$store.state.api.currentUser
    }
  },
  mounted () {
    this.getMonthlyInvoices()
    this.getWeeklyInvoices()
  },
  methods: {

    getWeeklyInvoices () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id,
        month: this.selectedMonth + 1
      }

      this.$vs.loading()
      this.$store.dispatch('api/getWeeklyInvoices', payload).then((response) => {
        if (response.data.status) {
          this.weeklies = response.data.data
        }
        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    getMonthlyInvoices () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id
      }

      this.$vs.loading()
      this.$store.dispatch('api/getMonthlyInvoices', payload).then((response) => {
        if (response.data.status) {
          this.monthlies = response.data.data
        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        title: 'Confirm',
        clickNotClose: true,
        acceptText: 'Ok',
        text
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const payload = {
            email: this.email,
            name: this.name,
            last_name: this.last_name,
            password: this.password,
            confirmPassword: this.password,
            user_group: this.user_group,
            active: 1
          }

          if (this.user_group === 2) {
            const property = {
              'Restaurant-Name': this.email
            }
            payload.property = property
          }

          this.$store.dispatch('api/registerUser', payload).then((response) => {
            this.$store.commit('api/SET_SELECTED_RESTAURANT', response.data.data)
            this.openAlert('Item saved successfully')
            this.addUser = false
            this.$router.push({name: 'restaurant-settings'})
          }).catch(err => {
            console.error(err.message)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
        }
      })
    }
  }
}
</script>
